module.exports = __webpack_public_path__ + "static/_kwantlenLogo-27c50eda32a16cb153bc340e9d63dc13.png";